import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import useSession from "../utils/useSession";
import { encryptPassword, decryptPassword } from "../../helpers/SecurityHelper";
import { toast } from "react-toastify";
import {
  PFModal,
  ESIModal,
  BonusModal,
  GratuityModal,
  GIModal,
  BidiModal,
} from "./PayrollModals";

const ParamSchema = Yup.object().shape({});

const pfFormInit = {
  Id: 0, PFDate: "", Rate: "", EmployerRate: "", PensionRate: "",
  MaxPensionAmt: "", MaxWagesForPF: "", MaxWagesForPension: "",
  AdminCharges: "", AdminChargesMinAmount: "",
  AC21WithGroupIns: "", AC21WithGroupInsMinAmt: "",
  AC22WithGroupIns: "", AC22WithGroupInsMinAmt: "",
  AC21WithoutGroupIns: "", AC22WithoutGroupIns: "",
  HigherPensionRate: "", PFBasis: false, PensionOnArrear: false,
  AC21Individually: false, NewLabourCodeApplyDate: "", NewLabourCodeBasicPrec: "",
};

const esiFormInit = {
  Id: 0, ESIDate: "", EmployeeContribution: "", EmployerContribution: "",
  WagesLimit: "", RoundedOn: false, EmployerPartIndividually: false,
  EmployeeExemptionLimit: "", Rural: false,

  NewLabourCodeApplyDate: "", NewLabourCodeBasicPrec: "",
};

const bonusFormInit = {
  Id: 0, BonusDate: "", BonusRate: "", MaximumWages: "", 
  MaximumWagesLimit: "", MaximumBonus: "", MinimumBonus: "", MinimumBonusDays: "",
};

const gratuityFormInit = {
  Id: 0, GratuityDate: "", Rate: "",
};

const giFormInit = {
  Id: 0, GIDate: "", GroupInsurance: false,
};

const bidiFormInit = {
  Id: 0, BidiDate: "", TonBidiRate: "0",
};


const CB = ({ label, name, value, onChange, col = "col-md-4" }) => (
  <div className={`${col} mb-2 d-flex align-items-center`}>
    <div className="form-check me-2">
      <input
        type="checkbox"
        className="form-check-input"
        id={name}
        name={name}
        checked={!!value}
        onChange={onChange}
      />
    </div>
    <label className="form-check-label mb-0" htmlFor={name} style={{ fontSize: 13, cursor: "pointer" }}>
      {label}
    </label>
  </div>
);

const AddEdit_PayrollParameter = () => {
  const [activeTab, setActiveTab] = useState("basicInfo");
  const [pfModalOpen, setPfModalOpen] = useState(false);
  const [pfForm, setPfForm] = useState(pfFormInit);
  const [pfRecords, setPfRecords] = useState([]);
  const [pfIndex, setPfIndex] = useState(0);
  const [pfEditMode, setPfEditMode] = useState(true);
  const setPF = (k, v) => setPfForm(p => ({ ...p, [k]: v }));

  const [esiModalOpen, setEsiModalOpen] = useState(false);
  const [esiForm, setEsiForm] = useState(esiFormInit);
  const [esiRecords, setEsiRecords] = useState([]);
  const [esiIndex, setEsiIndex] = useState(0);
  const [esiEditMode, setEsiEditMode] = useState(true);
  const setESI = (k, v) => setEsiForm(p => ({ ...p, [k]: v }));

  const [bonusModalOpen, setBonusModalOpen] = useState(false);
  const [bonusForm, setBonusForm] = useState(bonusFormInit);
  const [bonusRecords, setBonusRecords] = useState([]);
  const [bonusIndex, setBonusIndex] = useState(0);
  const [bonusEditMode, setBonusEditMode] = useState(true);
  const setBonus = (k, v) => setBonusForm(p => ({ ...p, [k]: v }));

  const [gratuityModalOpen, setGratuityModalOpen] = useState(false);
  const [gratuityForm, setGratuityForm] = useState(gratuityFormInit);
  const [gratuityRecords, setGratuityRecords] = useState([]);
  const [gratuityIndex, setGratuityIndex] = useState(0);
  const [gratuityEditMode, setGratuityEditMode] = useState(true);
  const setGratuity = (k, v) => setGratuityForm(p => ({ ...p, [k]: v }));

  const [giModalOpen, setGiModalOpen] = useState(false);
  const [giForm, setGiForm] = useState(giFormInit);
  const [giRecords, setGiRecords] = useState([]);
  const [giIndex, setGiIndex] = useState(0);
  const [giEditMode, setGiEditMode] = useState(true);
  const setGI = (k, v) => setGiForm(p => ({ ...p, [k]: v }));

  const [bidiModalOpen, setBidiModalOpen] = useState(false);
  const [bidiForm, setBidiForm] = useState(bidiFormInit);
  const [bidiRecords, setBidiRecords] = useState([]);
  const [bidiIndex, setBidiIndex] = useState(0);
  const [bidiEditMode, setBidiEditMode] = useState(true);
  const setBidi = (k, v) => setBidiForm(p => ({ ...p, [k]: v }));


  const [extraPayMasterList, setExtraPayMasterList] = useState([]);
  const [showDeletePass, setShowDeletePass] = useState(false);

  const [state, setState] = useState({
    id: 0,
    PFData: [],
    formData: {
      // ── Basic Information ──
      EmployerName: "",
      Address: "",
      Designation: "",
      Bank: "",
      CreatePayrollAutomatically: false,
      PayrollOrderBy: "",
      DepartmentWisePayroll: false,
      RetirementAge: "58",
      MinWages: "",
      FixMonthDays: "",
      WorkingHours: 8,
      ESIOnOT: false,
      PFOnOT: false,
      SundayInclude: false,
      SundayIncludeDeptwise: false,
      HourlyPayment: false,
      WagesRoundedOff: false,
      ArrearApplicable: false,
      PFOnArrear: false,
      ESIOnArrear: false,
      AllowancesOnArrear: false,
      DirectWagesEntry: false,
      DirectWagesDepartmentwise: false,
      NetPayableRoundedOff: false,
      CopyDaysToNextEmployee: false,
      MonthDayWithWHInBonus: false,
      LeaveWagesAmountOnBasicSalary: false,
      DisplayLeaveWagesPayment: false,
      OpLeaveWWagesInPayrollT: false,
      LeaveWithWagesDepartmentwise: false,
      GratuityEligibilityMonths: "",
      GratuityPayableDaysInMonth: "",
      ShowCompanyNameInDepartment: false,
      MultiESICode: false,
      MultiPF: false,
      MultiFactoryFirm: false,
      AllowanceDeductionEditable: false,
      AddOvertimeAmountInNetPayable: false,
      DontShowNCPInForm10C: false,
      CheckDuplicatePFNoEntry: false,
      CheckDuplicateESINoEntry: false,
      ShowForm3AWith0: false,
      NoWeeklyHolidayForDailyWages: false,
      NoDataOfContractor: false,
      NoPensionDataInWagesRegister: false,
      BasicEditable: false,
      CRLOnMonthDays: false,
      FirmHoliday: "",
      PFESIDuePaidDepartmentwise: false,
      AskToUpdatePaid: false,
      PieceWiseCalculation: false,
      // Auto Code fields
      IsAuto: false,
      Prefix: "",
      Suffix: "",
      StartNo: 1,
      PaddingDigits: 0,
      // ── Other Information ──
      ESIEnabled: false,
      PFEnabled: false,
      GratuityRates: false,
      CRLDays: false,
      OverTime: false,
      Recovery: false,
      Advance: false,
      TDS: false,
      AdvanceBonus: false,
      PFAdvRefund: false,
      PFSection: "",
      MaxLwW: "",
      LwWUsage: "",
      MultiDepartmentSelection: false,
      Days26Working: false,
      Days26WorkingEmployeeWise: false,
      AddAbsentInPFChallan: false,
      BonusOnWorkingDays: false,
      MonthDayWOSundayForDailyWages: false,
      AC2122OnFixedMaxPFWages: false,
      DepartmentInWagesRegisterOrderWise: false,
      OverLimitESICalcOnESILimit: false,
      FullESIByEmployer: false,
      TransactionLocked: false,
      OvertimeOnGrossWages: false,
      EntryFromExternal: false,
      DoubleOvertimeAmount: false,
      BonusOnMinWages: false,
      MinWagesEditable: false,
      FullPFByEmployer: false,
      MaxLeaveValidate: false,
      OvertimeOn26Days: false,
      BonusMonthlyInPayroll: false,
      F_ExtraPayMaster1: "",
      F_ExtraPayMaster2: "",
      F_ExtraPayMaster3: "",
      DeletePassword: "",
      // ── Allow Deduction ──
      FactoryActAddressDetails: "",
      PFAddressDetails: "",
      ESIAddressDetails: "",
    },
    isProgress: false,
  });

  const { firmId: sessionFirmId, firm: sessionFirm } = useSession();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_GET = API_WEB_URLS.MASTER + '/0/token/PayrollParameter/TBL.F_FirmMaster/';
  const API_URL_SAVE = "PayrollParameter/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/PayrollParameterEdit/Id`;

useEffect(() => {
  const fetchData = async () => {
    const Id = (location.state && location.state.Id) || 0;
    const firmId = sessionFirmId || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;

    // Fetch ExtraPayMaster list for this firm
    const extraPays = await Fn_FillListData(
      dispatch,
      () => {},
      "Data",
      `${API_WEB_URLS.MASTER}/0/token/ExtraPayMaster/TBL.F_FirmMaster/${firmId}`
    );
    const sortedExtraPays = (extraPays || []).sort(
      (a, b) => (Number(a.Ordering) || 0) - (Number(b.Ordering) || 0)
    );
    setExtraPayMasterList(sortedExtraPays);

    // ✅ GET list data
   const res= await Fn_FillListData(
      dispatch,
      () => {},
      "Data",
      `${API_URL_GET}${firmId}`
    );
console.log("Fetched PayrollParameter data:", res);

    // ✅ If data array exists and has records, populate form
    if (res && Array.isArray(res) && res.length > 0) {
      const data = res[0]; // Use first record
      const decryptedDeletePass = await decryptPassword(data.DeletePassword);
      
      // Determine PayrollOrderBy based on boolean flags
      let payrollOrderBy = "";
      if (data.IsPFNoWise) payrollOrderBy = "PFNoWise";
      else if (data.IsSerialNoWise) payrollOrderBy = "SerialNoWise";  
      else if (data.IsNameWise) payrollOrderBy = "NameWise";
      else if (data.IsCardNoWise) payrollOrderBy = "CardNoWise";

      setState((prev) => ({
        ...prev,
        id: data.Id || 0,
        formData: {
          // ── Basic Information ──
          EmployerName: data.EmployerName || "",
          Address: data.Address || "",
          Designation: data.Designation || "",
          Bank: data.Bank || "",
          CreatePayrollAutomatically: !!data.IsAutoPayroll,
          PayrollOrderBy: payrollOrderBy,
          DepartmentWisePayroll: !!data.IsDepartmentWisePayroll,
          RetirementAge: data.RetirementAge || "",
          MinWages: data.MinWages || "",
          FixMonthDays: data.FixMonthDays !== undefined && data.FixMonthDays !== null ? data.FixMonthDays : "",
          WorkingHours: data.WorkingHours !== undefined && data.WorkingHours !== null ? data.WorkingHours : 8,
          ESIOnOT: !!data.IsESIOnOT,
          PFOnOT: !!data.IsPFOnOT,
          SundayInclude: !!data.IsSundayInclude,
          SundayIncludeDeptwise: !!data.IsSundayDeptWise,
          HourlyPayment: !!data.IsHourlyPayment,
          WagesRoundedOff: !!data.IsWagesRoundedOff,
          ArrearApplicable: !!data.IsArrearApplicable,
          PFOnArrear: !!data.IsPFOnArrear,
          ESIOnArrear: !!data.IsESIOnArrear,
          AllowancesOnArrear: !!data.IsAllowanceOnArrear,
          DirectWagesEntry: !!data.IsDirectWagesEntry,
          DirectWagesDepartmentwise: !!data.IsDirectWagesDeptWise,
          NetPayableRoundedOff: !!data.IsNetPayRounded,
          CopyDaysToNextEmployee: !!data.IsCopyDaysNextEmployee,
          MonthDayWithWHInBonus: !!data.IsMonthDayWithINBonus,
          LeaveWagesAmountOnBasicSalary: !!data.IsLeaveOnBasicSalary,
          DisplayLeaveWagesPayment: !!data.IsDisplayLeaveWithWages,
          OpLeaveWWagesInPayrollT: !!data.IsOpenLeaveWithWages,
          LeaveWithWagesDepartmentwise: !!data.IsLeaveDepartmentWise,
          GratuityEligibilityMonths: data.GratuityEligibilityMonths || "",
          GratuityPayableDaysInMonth: data.GratuityPayableDays || "",
          ShowCompanyNameInDepartment: false,
          MultiESICode: !!data.IsMultiESI,
          MultiPF: !!data.IsMultiPF,
          MultiFactoryFirm: false,
          AllowanceDeductionEditable: !!data.IsAllowanceDeductionEditable,
          AddOvertimeAmountInNetPayable: !!data.IsAddOvertimeInNet,
          DontShowNCPInForm10C: !!data.IsHideNCPInForm16,
          CheckDuplicatePFNoEntry: !!data.IsCheckDuplicatePF,
          CheckDuplicateESINoEntry: !!data.IsCheckDuplicateESI,
          ShowForm3AWith0: !!data.IsShowForm3AZero,
          NoWeeklyHolidayForDailyWages: !!data.IsNoWeeklyHolidayDailyWages,
          NoDataOfContractor: !!data.IsNoContractorData,
          NoPensionDataInWagesRegister: !!data.IsNoPensionData,
          BasicEditable: !!data.IsBasicEditable,
          CRLOnMonthDays: !!data.IsCRLOnMonthDays,
          FirmHoliday: data.F_FirmHoliday || "",
          PFESIDuePaidDepartmentwise: !!data.IsPFESIDeptWise,
          AskToUpdatePaid: !!data.IsAskUpdatePaid,
          PieceWiseCalculation: !!data.IsPieceWiseCalculation,
          // Auto Code fields
          IsAuto: !!data.IsAuto,
          Prefix: data.Prefix || "",
          Suffix: data.Suffix || "",
          StartNo: data.StartNo !== undefined ? data.StartNo : 1,
          PaddingDigits: data.PaddingDigits !== undefined ? data.PaddingDigits : 0,
          // ── Other Information ──
          ESIEnabled: !!data.IsESI,
          PFEnabled: !!data.IsPF,
          GratuityRates: !!data.IsGratuity,
          CRLDays: !!data.IsCRLDays,
          OverTime: !!data.IsOvertime,
          Recovery: !!data.IsRecovery,
          Advance: !!data.IsAdvance,
          TDS: !!data.IsTDS,
          AdvanceBonus: !!data.IsAdvanceBonus,
          PFAdvRefund: !!data.IsPFAdvRefund,
          PFSection: data.PFSection || "",
          MaxLwW: "",
          LwWUsage: "",
          MultiDepartmentSelection: !!data.IsMultiDepartment,
          Days26Working: !!data.Is26DaysWorking,
          Days26WorkingEmployeeWise: !!data.Is26DaysEmployeeWise,
          AddAbsentInPFChallan: !!data.IsAddAbsentInPF,
          BonusOnWorkingDays: !!data.IsBonusOnWorkingDays,
          MonthDayWOSundayForDailyWages: !!data.IsMonthDayWithoutSunday,
          AC2122OnFixedMaxPFWages: !!data.IsAC212OnFixedPF,
          DepartmentInWagesRegisterOrderWise: !!data.IsDeptOrderWise,
          OverLimitESICalcOnESILimit: !!data.IsOverLimitESI,
          FullESIByEmployer: !!data.IsFullESIEmployer,
          TransactionLocked: !!data.IsTransactionLocked,
          OvertimeOnGrossWages: !!(data.IsOTOnGross || data.OvertimeOnGrossWages),
          EntryFromExternal: !!data.IsEntryFromExternal,
          DoubleOvertimeAmount: !!(data.IsDoubleOT || data.DoubleOvertimeAmount),
          BonusOnMinWages: !!data.IsBonusOnMinWages,
          MinWagesEditable: !!data.IsMinWagesEditable,
          FullPFByEmployer: !!data.IsFullPFEmployer,
          MaxLeaveValidate: !!(data.IsMaxLeaveValidate || data.MaxLeaveValidate),
          OvertimeOn26Days: !!(data.IsOTOn26Days || data.OvertimeOn26Days || data.IsOvertimeOn26Days),
          BonusMonthlyInPayroll: !!data.IsBonusMonthly,
          F_ExtraPayMaster1: data.F_ExtraPayMaster1 || "",
          F_ExtraPayMaster2: data.F_ExtraPayMaster2 || "",
          F_ExtraPayMaster3: data.F_ExtraPayMaster3 || "",
          DeletePassword: decryptedDeletePass || "",
          // ── Address Details ──
          FactoryActAddressDetails: "",
          PFAddressDetails: "",
          ESIAddressDetails: "",
        }
      }));
    }
    // ✅ If edit mode
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  };

  fetchData();
}, [dispatch, location.state, sessionFirmId]);

  const loadPfRecord = (rec) => {
    setPfForm({
      Id: rec.Id || 0,
      PFDate: rec.PFDate ? String(rec.PFDate).substring(0, 10) : "",
      Rate: rec.Rate || "", EmployerRate: rec.EmployerRate || "",
      PensionRate: rec.PensionRate || "", MaxPensionAmt: rec.MaxPensionAmt || "",
      MaxWagesForPF: rec.MaxWagesForPF || "", MaxWagesForPension: rec.MaxWagesForPension || "",
      AdminCharges: rec.AdminCharges || "", AdminChargesMinAmount: rec.AdminChargesMinAmount || "",
      AC21WithGroupIns: rec.AC21WithGroupIns || "", AC21WithGroupInsMinAmt: rec.AC21WithGroupInsMinAmt || "",
      AC22WithGroupIns: rec.AC22WithGroupIns || "", AC22WithGroupInsMinAmt: rec.AC22WithGroupInsMinAmt || "",
      AC21WithoutGroupIns: rec.AC21WithoutGroupIns || "", AC22WithoutGroupIns: rec.AC22WithoutGroupIns || "",
      HigherPensionRate: rec.HigherPensionRate || "",
      PFBasis: !!rec.PFBasis, PensionOnArrear: !!rec.PensionOnArrear, AC21Individually: !!rec.AC21Individually,
      NewLabourCodeApplyDate: rec.NewLabourCodeApplyDate ? String(rec.NewLabourCodeApplyDate).substring(0, 10) : "",
      NewLabourCodeBasicPrec: rec.NewLabourCodeBasicPrec || "",
    });
  };

  const navigatePf = (idx) => {
    if (!pfRecords.length) return;
    const i = Math.max(0, Math.min(pfRecords.length - 1, idx));
    setPfIndex(i);
    loadPfRecord(pfRecords[i]);
    setPfEditMode(false);
  };

  const PfParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/PfParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.PFDate) - new Date(b.PFDate));
      setPfRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setPfIndex(latestIdx);
        loadPfRecord(sorted[latestIdx]);
        setPfEditMode(false);
      } else {
        setPfForm({ ...pfFormInit });
        setPfEditMode(true);
      }
    } catch {
      setPfRecords([]);
      setPfForm({ ...pfFormInit });
      setPfEditMode(true);
    }
  };

  // Restore JSON rows on edit
  useEffect(() => {
    const f = state.formData;
    if (!f) return;
    // No longer needed for allowance/deduction
  }, [state.formData]);



  const handlePFSave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      fd.append("PFDate", pfForm.PFDate || "");
      fd.append("Rate", pfForm.Rate !== "" && pfForm.Rate !== undefined && pfForm.Rate !== null ? pfForm.Rate : 0);
      fd.append("EmployerRate", pfForm.EmployerRate !== "" && pfForm.EmployerRate !== undefined && pfForm.EmployerRate !== null ? pfForm.EmployerRate : 0);
      fd.append("PensionRate", pfForm.PensionRate !== "" && pfForm.PensionRate !== undefined && pfForm.PensionRate !== null ? pfForm.PensionRate : 0);
      fd.append("MaxPensionAmt", pfForm.MaxPensionAmt !== "" && pfForm.MaxPensionAmt !== undefined && pfForm.MaxPensionAmt !== null ? pfForm.MaxPensionAmt : 0);
      fd.append("MaxWagesForPF", pfForm.MaxWagesForPF !== "" && pfForm.MaxWagesForPF !== undefined && pfForm.MaxWagesForPF !== null ? pfForm.MaxWagesForPF : 0);
      fd.append("MaxWagesForPension", pfForm.MaxWagesForPension !== "" && pfForm.MaxWagesForPension !== undefined && pfForm.MaxWagesForPension !== null ? pfForm.MaxWagesForPension : 0);
      fd.append("AdminCharges", pfForm.AdminCharges !== "" && pfForm.AdminCharges !== undefined && pfForm.AdminCharges !== null ? pfForm.AdminCharges : 0);
      fd.append("AdminChargesMinAmount", pfForm.AdminChargesMinAmount !== "" && pfForm.AdminChargesMinAmount !== undefined && pfForm.AdminChargesMinAmount !== null ? pfForm.AdminChargesMinAmount : 0);
      fd.append("AC21WithGroupIns", pfForm.AC21WithGroupIns !== "" && pfForm.AC21WithGroupIns !== undefined && pfForm.AC21WithGroupIns !== null ? pfForm.AC21WithGroupIns : 0);
      fd.append("AC21WithGroupInsMinAmt", pfForm.AC21WithGroupInsMinAmt !== "" && pfForm.AC21WithGroupInsMinAmt !== undefined && pfForm.AC21WithGroupInsMinAmt !== null ? pfForm.AC21WithGroupInsMinAmt : 0);
      fd.append("AC22WithGroupIns", pfForm.AC22WithGroupIns !== "" && pfForm.AC22WithGroupIns !== undefined && pfForm.AC22WithGroupIns !== null ? pfForm.AC22WithGroupIns : 0);
      fd.append("AC22WithGroupInsMinAmt", pfForm.AC22WithGroupInsMinAmt !== "" && pfForm.AC22WithGroupInsMinAmt !== undefined && pfForm.AC22WithGroupInsMinAmt !== null ? pfForm.AC22WithGroupInsMinAmt : 0);
      fd.append("AC21WithoutGroupIns", pfForm.AC21WithoutGroupIns !== "" && pfForm.AC21WithoutGroupIns !== undefined && pfForm.AC21WithoutGroupIns !== null ? pfForm.AC21WithoutGroupIns : 0);
      fd.append("AC22WithoutGroupIns", pfForm.AC22WithoutGroupIns !== "" && pfForm.AC22WithoutGroupIns !== undefined && pfForm.AC22WithoutGroupIns !== null ? pfForm.AC22WithoutGroupIns : 0);
      fd.append("HigherPensionRate", pfForm.HigherPensionRate !== "" && pfForm.HigherPensionRate !== undefined && pfForm.HigherPensionRate !== null ? pfForm.HigherPensionRate : 0);

      // Explicit boolean formatting to prevent ASP.NET ModelState validation error
      fd.append("PFBasis", pfForm.PFBasis ? true : false);
      fd.append("PensionOnArrear", pfForm.PensionOnArrear ? true : false);
      fd.append("AC21Individually", pfForm.AC21Individually ? true : false);

      fd.append("NewLabourCodeApplyDate", pfForm.NewLabourCodeApplyDate || "");
      fd.append("NewLabourCodeBasicPrec", pfForm.NewLabourCodeBasicPrec !== "" && pfForm.NewLabourCodeBasicPrec !== undefined && pfForm.NewLabourCodeBasicPrec !== null ? pfForm.NewLabourCodeBasicPrec : 0);
      fd.append("UserId", 0);

      await Fn_AddEditData(dispatch, setState, { arguList: { id: pfForm.Id, formData: fd } }, "PFParameter/0/token", true, "memberid", navigate, "#");
      // Refresh records after save
      await PfParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const loadEsiRecord = (rec) => {
    setEsiForm({
      Id: rec.Id || 0,
      ESIDate: rec.ESIDate ? String(rec.ESIDate).substring(0, 10) : "",
      EmployeeContribution: rec.EmployeeContribution !== undefined && rec.EmployeeContribution !== null ? rec.EmployeeContribution : "",
      EmployerContribution: rec.EmployerContribution !== undefined && rec.EmployerContribution !== null ? rec.EmployerContribution : "",
      WagesLimit: rec.WagesLimit !== undefined && rec.WagesLimit !== null ? rec.WagesLimit : "",
      RoundedOn: Boolean(rec.RoundedOn),
      EmployerPartIndividually: Boolean(rec.EmployerPartIndividually),
      EmployeeExemptionLimit: rec.EmployeeExemptionLimit !== undefined && rec.EmployeeExemptionLimit !== null ? rec.EmployeeExemptionLimit : "",
      Rural: Boolean(rec.Rural),
      NewLabourCodeApplyDate: rec.NewLabourCodeApplyDate ? String(rec.NewLabourCodeApplyDate).substring(0, 10) : "",
      NewLabourCodeBasicPrec: rec.NewLabourCodeBasicPrec !== undefined && rec.NewLabourCodeBasicPrec !== null ? rec.NewLabourCodeBasicPrec : "",
    });
  };

  const loadBonusRecord = (rec) => {
    setBonusForm({
      Id: rec.Id || 0,
      BonusDate: rec.BonusDate ? String(rec.BonusDate).substring(0, 10) : "",
      BonusRate: rec.BonusRate !== undefined && rec.BonusRate !== null ? rec.BonusRate : "",
      MaximumWages: rec.MaximumWages !== undefined && rec.MaximumWages !== null ? rec.MaximumWages : "",
      MaximumWagesLimit: rec.MaximumWagesLimit !== undefined && rec.MaximumWagesLimit !== null ? rec.MaximumWagesLimit : "",
      MaximumBonus: rec.MaximumBonus !== undefined && rec.MaximumBonus !== null ? rec.MaximumBonus : "",
      MinimumBonus: rec.MinimumBonus !== undefined && rec.MinimumBonus !== null ? rec.MinimumBonus : "",
      MinimumBonusDays: rec.MinimumBonusDays !== undefined && rec.MinimumBonusDays !== null ? rec.MinimumBonusDays : "",
    });
  };

  const loadGratuityRecord = (rec) => {
    setGratuityForm({
      Id: rec.Id || 0,
      GratuityDate: rec.GratuityDate ? String(rec.GratuityDate).substring(0, 10) : "",
      Rate: rec.Rate !== undefined && rec.Rate !== null ? rec.Rate : "",
    });
  };

  const navigateEsi = (idx) => {
    if (!esiRecords.length) return;
    const i = Math.max(0, Math.min(esiRecords.length - 1, idx));
    setEsiIndex(i);
    loadEsiRecord(esiRecords[i]);
    setEsiEditMode(false);
  };

  const navigateBonus = (idx) => {
    if (!bonusRecords.length) return;
    const i = Math.max(0, Math.min(bonusRecords.length - 1, idx));
    setBonusIndex(i);
    loadBonusRecord(bonusRecords[i]);
    setBonusEditMode(false);
  };

  const navigateGratuity = (idx) => {
    if (!gratuityRecords.length) return;
    const i = Math.max(0, Math.min(gratuityRecords.length - 1, idx));
    setGratuityIndex(i);
    loadGratuityRecord(gratuityRecords[i]);
    setGratuityEditMode(false);
  };

  const EsiParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/EsiParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.ESIDate) - new Date(b.ESIDate));
      setEsiRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setEsiIndex(latestIdx);
        loadEsiRecord(sorted[latestIdx]);
        setEsiEditMode(false);
      } else {
        setEsiForm({ ...esiFormInit });
        setEsiEditMode(true);
      }
    } catch {
      setEsiRecords([]);
      setEsiForm({ ...esiFormInit });
      setEsiEditMode(true);
    }
  };

  const BonusParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/BonusParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.BonusDate) - new Date(b.BonusDate));
      setBonusRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setBonusIndex(latestIdx);
        loadBonusRecord(sorted[latestIdx]);
        setBonusEditMode(false);
      } else {
        setBonusForm({ ...bonusFormInit });
        setBonusEditMode(true);
      }
    } catch {
      setBonusRecords([]);
      setBonusForm({ ...bonusFormInit });
      setBonusEditMode(true);
    }
  };

  const GratuityParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/GratuityParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.GratuityDate) - new Date(b.GratuityDate));
      setGratuityRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setGratuityIndex(latestIdx);
        loadGratuityRecord(sorted[latestIdx]);
        setGratuityEditMode(false);
      } else {
        setGratuityForm({ ...gratuityFormInit });
        setGratuityEditMode(true);
      }
    } catch {
      setGratuityRecords([]);
      setGratuityForm({ ...gratuityFormInit });
      setGratuityEditMode(true);
    }
  };

  const handleESISave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      fd.append("ESIDate", esiForm.ESIDate || "");
      fd.append("EmployeeContribution", esiForm.EmployeeContribution !== "" && esiForm.EmployeeContribution !== undefined && esiForm.EmployeeContribution !== null ? esiForm.EmployeeContribution : 0);
      fd.append("EmployerContribution", esiForm.EmployerContribution !== "" && esiForm.EmployerContribution !== undefined && esiForm.EmployerContribution !== null ? esiForm.EmployerContribution : 0);
      fd.append("WagesLimit", esiForm.WagesLimit !== "" && esiForm.WagesLimit !== undefined && esiForm.WagesLimit !== null ? esiForm.WagesLimit : 0);
      fd.append("RoundedOn", esiForm.RoundedOn ? true : false);
      fd.append("EmployerPartIndividually", esiForm.EmployerPartIndividually ? true : false);
      fd.append("EmployeeExemptionLimit", esiForm.EmployeeExemptionLimit !== "" && esiForm.EmployeeExemptionLimit !== undefined && esiForm.EmployeeExemptionLimit !== null ? esiForm.EmployeeExemptionLimit : 0);
      fd.append("Rural", esiForm.Rural ? true : false);
      fd.append("NewLabourCodeApplyDate", esiForm.NewLabourCodeApplyDate || "");
      fd.append("NewLabourCodeBasicPrec", esiForm.NewLabourCodeBasicPrec !== "" && esiForm.NewLabourCodeBasicPrec !== undefined && esiForm.NewLabourCodeBasicPrec !== null ? esiForm.NewLabourCodeBasicPrec : 0);
      fd.append("UserId", 0);

      await Fn_AddEditData(dispatch, setState, { arguList: { id: esiForm.Id, formData: fd } }, "ESISettings/0/token", true, "memberid", navigate, "#");
      await EsiParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const handleBonusSave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      fd.append("BonusDate", bonusForm.BonusDate || "");
      fd.append("BonusRate", bonusForm.BonusRate !== "" && bonusForm.BonusRate !== undefined && bonusForm.BonusRate !== null ? bonusForm.BonusRate : 0);
      fd.append("MaximumWages", bonusForm.MaximumWages !== "" && bonusForm.MaximumWages !== undefined && bonusForm.MaximumWages !== null ? bonusForm.MaximumWages : 0);
      fd.append("MaximumWagesLimit", bonusForm.MaximumWagesLimit !== "" && bonusForm.MaximumWagesLimit !== undefined && bonusForm.MaximumWagesLimit !== null ? bonusForm.MaximumWagesLimit : 0);
      fd.append("MaximumBonus", bonusForm.MaximumBonus !== "" && bonusForm.MaximumBonus !== undefined && bonusForm.MaximumBonus !== null ? bonusForm.MaximumBonus : 0);
      fd.append("MinimumBonus", bonusForm.MinimumBonus !== "" && bonusForm.MinimumBonus !== undefined && bonusForm.MinimumBonus !== null ? bonusForm.MinimumBonus : 0);
      fd.append("MinimumBonusDays", bonusForm.MinimumBonusDays !== "" && bonusForm.MinimumBonusDays !== undefined && bonusForm.MinimumBonusDays !== null ? bonusForm.MinimumBonusDays : 0);
      fd.append("UserId", 0);

      await Fn_AddEditData(dispatch, setState, { arguList: { id: bonusForm.Id, formData: fd } }, "BonusParameter/0/token", true, "memberid", navigate, "#");
      await BonusParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const handleGratuitySave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      fd.append("GratuityDate", gratuityForm.GratuityDate || "");
      fd.append("Rate", gratuityForm.Rate !== "" && gratuityForm.Rate !== undefined && gratuityForm.Rate !== null ? gratuityForm.Rate : 0);
      fd.append("UserId", 0);

      await Fn_AddEditData(dispatch, setState, { arguList: { id: gratuityForm.Id, formData: fd } }, "GratuityParameter/0/token", true, "memberid", navigate, "#");
      await GratuityParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const loadGiRecord = (rec) => {
    setGiForm({
      Id: rec.Id || 0,
      GIDate: rec.GIDate ? String(rec.GIDate).substring(0, 10) : "",
      GroupInsurance: Boolean(rec.IsGroupInsurance ?? rec.GroupInsurance ?? rec.IsGI),
    });
  };

  const navigateGi = (idx) => {
    if (!giRecords.length) return;
    const i = Math.max(0, Math.min(giRecords.length - 1, idx));
    setGiIndex(i);
    loadGiRecord(giRecords[i]);
    setGiEditMode(false);
  };

  const GIParamFetch = async (firmId) => {
    try {
      let res = await Fn_FillListData(
        dispatch,
        () => {},
        "Data",
        `${API_WEB_URLS.MASTER}/0/token/GroupInsurance/Tbl.F_FirmMaster/${firmId}`
      );
      const sorted = (res || []).sort(
        (a, b) => (new Date(a.GIDate || 0) - new Date(b.GIDate || 0)) || ((a.Id || 0) - (b.Id || 0))
      );
      setGiRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setGiIndex(latestIdx);
        loadGiRecord(sorted[latestIdx]);
        setGiEditMode(false);
      } else {
        setGiForm({ ...giFormInit });
        setGiEditMode(true);
      }
    } catch {
      setGiRecords([]);
      setGiForm({ ...giFormInit });
      setGiEditMode(true);
    }
  };

  const handleGISave = async () => {
    try {
      const fd = new FormData();
      const firmId = sessionFirmId || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      fd.append("GIDate", giForm.GIDate || "");
      fd.append("IsGroupInsurance", giForm.GroupInsurance ? true : false);
      fd.append("GroupInsurance", giForm.GroupInsurance ? true : false);
      fd.append("IsNotInUse", false);
      fd.append("UserId", 0);

      await Fn_AddEditData(dispatch, setState, { arguList: { id: giForm.Id, formData: fd } }, "GroupInsurance/0/token", true, "memberid", navigate, "#");
      await GIParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const loadBidiRecord = (rec) => {
    setBidiForm({
      Id: rec.Id || 0,
      BidiDate: rec.BidiDate ? String(rec.BidiDate).substring(0, 10) : "",
      TonBidiRate: rec.TonBidiRate !== undefined && rec.TonBidiRate !== null ? rec.TonBidiRate : (rec.BidiRate !== undefined && rec.BidiRate !== null ? rec.BidiRate : (rec.Rate !== undefined && rec.Rate !== null ? rec.Rate : "0")),
    });
  };

  const navigateBidi = (idx) => {
    if (!bidiRecords.length) return;
    const i = Math.max(0, Math.min(bidiRecords.length - 1, idx));
    setBidiIndex(i);
    loadBidiRecord(bidiRecords[i]);
    setBidiEditMode(false);
  };

  const BidiParamFetch = async (firmId) => {
    try {
      let res = await Fn_FillListData(
        dispatch,
        () => {},
        "Data",
        `${API_WEB_URLS.MASTER}/0/token/BidiRateParameter/Tbl.F_FirmMaster/${firmId}`
      );
      const sorted = (res || []).sort(
        (a, b) => (new Date(a.BidiDate || 0) - new Date(b.BidiDate || 0)) || ((a.Id || 0) - (b.Id || 0))
      );
      setBidiRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setBidiIndex(latestIdx);
        loadBidiRecord(sorted[latestIdx]);
        setBidiEditMode(false);
      } else {
        setBidiForm({ ...bidiFormInit });
        setBidiEditMode(true);
      }
    } catch {
      setBidiRecords([]);
      setBidiForm({ ...bidiFormInit });
      setBidiEditMode(true);
    }
  };

  const handleBidiSave = async () => {
    try {
      const fd = new FormData();
      const firmId = sessionFirmId || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      fd.append("BidiDate", bidiForm.BidiDate || "");
      fd.append("TonBidiRate", bidiForm.TonBidiRate !== "" && bidiForm.TonBidiRate !== undefined && bidiForm.TonBidiRate !== null ? bidiForm.TonBidiRate : 0);
      fd.append("IsNotInUse", false);
      fd.append("UserId", 0);

      await Fn_AddEditData(dispatch, setState, { arguList: { id: bidiForm.Id, formData: fd } }, "BidiRateParameter/0/token", true, "memberid", navigate, "#");
      await BidiParamFetch(firmId);
    } catch (e) { console.error(e); }
  };


  
  const handleSubmit = async (values) => {
    try {
      const fd = new FormData();
      
      // F_FirmMaster is required for save
      const firmId = sessionFirmId || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      if (!firmId || firmId <= 0) {
        toast.error("Please select a Firm from the top header session before saving Payroll Parameter!");
        return;
      }
      fd.append("F_FirmMaster", firmId);

      // ── Basic Information ──
      fd.append("EmployerName",                    values.EmployerName                    || "");
      fd.append("Address",                         values.Address                         || "");
      fd.append("Designation",                     values.Designation                     || "");
      fd.append("Bank",                            values.Bank                            || "");
      fd.append("IsAutoPayroll",                   values.CreatePayrollAutomatically      ? true : false);
      
      // PayrollOrderBy maps to separate boolean fields
      fd.append("IsPFNoWise",                      values.PayrollOrderBy === "PFNoWise" ? true : false);
      fd.append("IsSerialNoWise",                  values.PayrollOrderBy === "SerialNoWise" ? true : false);
      fd.append("IsNameWise",                      values.PayrollOrderBy === "NameWise" ? true : false);
      fd.append("IsCardNoWise",                    values.PayrollOrderBy === "CardNoWise" ? true : false);
      
      fd.append("IsDepartmentWisePayroll",         values.DepartmentWisePayroll           ? true : false);
      fd.append("RetirementAge",                   values.RetirementAge                   || "");
      fd.append("MinWages",                        values.MinWages                        || "");
      fd.append("FixMonthDays",                    values.FixMonthDays !== "" && values.FixMonthDays !== undefined && values.FixMonthDays !== null ? values.FixMonthDays : 0);
      fd.append("WorkingHours",                    values.WorkingHours !== "" && values.WorkingHours !== undefined && values.WorkingHours !== null ? values.WorkingHours : 8);
      fd.append("IsESIOnOT",                       values.ESIOnOT                         ? true : false);
      fd.append("IsPFOnOT",                        values.PFOnOT                          ? true : false);
      fd.append("IsSundayInclude",                 values.SundayInclude                   ? true : false);
      fd.append("IsSundayDeptWise",                values.SundayIncludeDeptwise           ? true : false);
      fd.append("IsHourlyPayment",                 values.HourlyPayment                   ? true : false);
      fd.append("IsWagesRoundedOff",               values.WagesRoundedOff                 ? true : false);
      fd.append("IsArrearApplicable",              values.ArrearApplicable                ? true : false);
      fd.append("IsPFOnArrear",                    values.PFOnArrear                      ? true : false);
      fd.append("IsESIOnArrear",                   values.ESIOnArrear                     ? true : false);
      fd.append("IsAllowanceOnArrear",             values.AllowancesOnArrear              ? true : false);
      fd.append("IsDirectWagesEntry",              values.DirectWagesEntry                ? true : false);
      fd.append("IsDirectWagesDeptWise",           values.DirectWagesDepartmentwise       ? true : false);
      fd.append("IsNetPayRounded",                 values.NetPayableRoundedOff            ? true : false);
      fd.append("IsCopyDaysNextEmployee",          values.CopyDaysToNextEmployee          ? true : false);
      fd.append("IsMonthDayWithINBonus",           values.MonthDayWithWHInBonus           ? true : false);
      fd.append("IsLeaveOnBasicSalary",            values.LeaveWagesAmountOnBasicSalary   ? true : false);
      fd.append("IsDisplayLeaveWithWages",         values.DisplayLeaveWagesPayment        ? true : false);
      fd.append("IsOpenLeaveWithWages",            values.OpLeaveWWagesInPayrollT         ? true : false);
      fd.append("IsLeaveDepartmentWise",           values.LeaveWithWagesDepartmentwise    ? true : false);
      fd.append("GratuityEligibilityMonths",       values.GratuityEligibilityMonths       || "");
      fd.append("GratuityPayableDays",             values.GratuityPayableDaysInMonth      || "");
      // fd.append("ShowCompanyNameInDepartment",     values.ShowCompanyNameInDepartment     ? true : false); // Not in API
      fd.append("IsMultiESI",                         values.MultiESICode                    ? true : false);
      fd.append("IsMultiPF",                          values.MultiPF                         ? true : false);
      // fd.append("MultiFactoryFirm",                values.MultiFactoryFirm                ? true : false); // Not in API (out of scope)
      fd.append("IsAllowanceDeductionEditable",   values.AllowanceDeductionEditable      ? true : false);
      fd.append("IsAddOvertimeInNet",              values.AddOvertimeAmountInNetPayable   ? true : false);
      fd.append("IsHideNCPInForm16",               values.DontShowNCPInForm10C            ? true : false);
      fd.append("IsCheckDuplicatePF",              values.CheckDuplicatePFNoEntry         ? true : false);
      fd.append("IsCheckDuplicateESI",             values.CheckDuplicateESINoEntry        ? true : false);
      fd.append("IsShowForm3AZero",                values.ShowForm3AWith0                 ? true : false);
      fd.append("IsNoWeeklyHolidayDailyWages",     values.NoWeeklyHolidayForDailyWages    ? true : false);
      fd.append("IsNoContractorData",              values.NoDataOfContractor              ? true : false);
      fd.append("IsNoPensionData",                 values.NoPensionDataInWagesRegister    ? true : false);
      fd.append("IsBasicEditable",                 values.BasicEditable                   ? true : false);
      fd.append("IsCRLOnMonthDays",                values.CRLOnMonthDays                  ? true : false);
      fd.append("F_FirmHoliday",                   values.FirmHoliday                     || "");
      fd.append("IsPFESIDeptWise",                 values.PFESIDuePaidDepartmentwise      ? true : false);
      fd.append("IsAskUpdatePaid",                 values.AskToUpdatePaid                 ? true : false);
      fd.append("IsPieceWiseCalculation",          values.PieceWiseCalculation            ? true : false);

      // ── Other Information ──
      fd.append("IsESI",                           values.ESIEnabled                      ? true : false);
      fd.append("IsPF",                            values.PFEnabled                       ? true : false);
      fd.append("IsGratuity",                      values.GratuityRates                   ? true : false);
      fd.append("IsCRLDays",                       values.CRLDays                         ? true : false);
      fd.append("IsOvertime",                      values.OverTime                        ? true : false);
      fd.append("IsRecovery",                      values.Recovery                        ? true : false);
      fd.append("IsAdvance",                       values.Advance                         ? true : false);
      fd.append("IsTDS",                           values.TDS                             ? true : false);
      fd.append("IsAdvanceBonus",                  values.AdvanceBonus                    ? true : false);
      fd.append("IsPFAdvRefund",                   values.PFAdvRefund                     ? true : false);
      fd.append("PFSection",                       values.PFSection                       || "");
      // fd.append("MaxLwW",                          values.MaxLwW                          || ""); // Not in API
      // fd.append("LwWUsage",                        values.LwWUsage                        || ""); // Not in API
      fd.append("IsMultiDepartment",               values.MultiDepartmentSelection        ? true : false);
      fd.append("Is26DaysWorking",                 values.Days26Working                   ? true : false);
      fd.append("Is26DaysEmployeeWise",            values.Days26WorkingEmployeeWise       ? true : false);
      fd.append("IsAddAbsentInPF",                 values.AddAbsentInPFChallan            ? true : false);
      fd.append("IsBonusOnWorkingDays",            values.BonusOnWorkingDays              ? true : false);
      fd.append("IsMonthDayWithoutSunday",         values.MonthDayWOSundayForDailyWages   ? true : false);
      fd.append("IsAC212OnFixedPF",                values.AC2122OnFixedMaxPFWages         ? true : false);
      fd.append("IsDeptOrderWise",                 values.DepartmentInWagesRegisterOrderWise ? true : false);
      fd.append("IsOverLimitESI",                  values.OverLimitESICalcOnESILimit      ? true : false);
      fd.append("IsFullESIEmployer",               values.FullESIByEmployer               ? true : false);
      fd.append("IsTransactionLocked",             values.TransactionLocked               ? true : false);
      fd.append("IsOTOnGross",                     values.OvertimeOnGrossWages            ? true : false);
      fd.append("IsEntryFromExternal",             values.EntryFromExternal               ? true : false);
      fd.append("IsDoubleOT",                      values.DoubleOvertimeAmount            ? true : false);
      fd.append("IsBonusOnMinWages",               values.BonusOnMinWages                 ? true : false);
      fd.append("IsMinWagesEditable",              values.MinWagesEditable                ? true : false);
      fd.append("IsFullPFEmployer",                values.FullPFByEmployer                ? true : false);
      fd.append("IsMaxLeaveValidate",              values.MaxLeaveValidate                ? true : false);
      fd.append("IsOTOn26Days",                    values.OvertimeOn26Days                ? true : false);
      
      fd.append("F_ExtraPayMaster1",               values.F_ExtraPayMaster1 || 0);
      fd.append("F_ExtraPayMaster2",               values.F_ExtraPayMaster2 || 0);
      fd.append("F_ExtraPayMaster3",               values.F_ExtraPayMaster3 || 0);
      
      fd.append("IsBonusMonthly",                  values.BonusMonthlyInPayroll           ? true : false);

      // Auto Code fields
      fd.append("IsAuto",                          values.IsAuto ? true : false);
      fd.append("Prefix",                          values.Prefix || "");
      fd.append("Suffix",                          values.Suffix || "");
      fd.append("StartNo",                         values.StartNo !== undefined && values.StartNo !== "" ? values.StartNo : 1);
      fd.append("PaddingDigits",                   values.PaddingDigits !== undefined && values.PaddingDigits !== "" ? values.PaddingDigits : 0);

      // Security & Deletion Authorization Password (always encrypted)
      const encDeletePassword = await encryptPassword(values.DeletePassword);
      fd.append("DeletePassword",                  encDeletePassword || "");

      // ── Address Details ──
      // fd.append("FactoryActAddressDetails",        values.FactoryActAddressDetails        || ""); // Not in API
      // fd.append("PFAddressDetails",                values.PFAddressDetails                || ""); // Not in API
      // fd.append("ESIAddressDetails",               values.ESIAddressDetails               || ""); // Not in API

      Fn_AddEditData(
        dispatch, setState,
        { arguList: { id: 0, formData: fd } },
        API_URL_SAVE, true, "memberid", navigate, "/PayrollParameter"
      );
    } catch (error) {
      console.error(error);
      alert("An error occurred. Please try again.");
    }
  };

  const tabs = [
    { key: "basicInfo",      label: "BASIC INFORMATION" },
    { key: "otherInfo",      label: "OTHER INFORMATION" },
    { key: "reportSettings", label: "REPORT SETTINGS" },
    { key: "addressDetails", label: "ADDRESS DETAILS" },
  ];

  return (
    <Fragment>
      <style>{`
        .payroll-param-wrapper .form-check-input[type="checkbox"] {
          width: 1.25rem !important;
          height: 1.25rem !important;
          margin-top: 0 !important;
          cursor: pointer !important;
          border: 1.5px solid #a0aec0 !important;
          border-radius: 4px !important;
          accent-color: #7c69ef !important;
          transition: all 0.15s ease-in-out !important;
          vertical-align: middle !important;
        }
        .payroll-param-wrapper .form-check-input[type="checkbox"]:checked {
          background-color: #7c69ef !important;
          border-color: #7c69ef !important;
        }
        .payroll-param-wrapper .form-check-input[type="checkbox"]:focus {
          box-shadow: 0 0 0 0.2rem rgba(124, 105, 239, 0.25) !important;
          border-color: #7c69ef !important;
        }
        .payroll-param-wrapper .form-check-input[type="radio"] {
          width: 1.2rem !important;
          height: 1.2rem !important;
          margin-top: 0 !important;
          cursor: pointer !important;
          accent-color: #7c69ef !important;
        }
        .payroll-param-wrapper .form-check-label {
          cursor: pointer !important;
          user-select: none !important;
          vertical-align: middle !important;
        }
      `}</style>

      <div className="payroll-param-wrapper">
        <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Payroll Parameter" />

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Payroll Parameter</h4>
                <span className="badge badge-primary px-3 py-2" style={{ fontSize: 13 }}>
                  🏢 Active Firm: {sessionFirm?.Name || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Name || "No Firm Selected"}
                </span>
              </div>
            <div className="card-body">

              <Formik
                initialValues={state.formData}
                enableReinitialize
                validationSchema={ParamSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => { handleSubmit(values); setSubmitting(false); }, 400);
                }}
              >
                {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => {
                  const sf = (name) => (e) => {
                    const checked = e.target.checked;
                    setFieldValue(name, checked);
                    if (checked && name === "Days26Working") {
                      setFieldValue("Days26WorkingEmployeeWise", false);
                    } else if (checked && name === "Days26WorkingEmployeeWise") {
                      setFieldValue("Days26Working", false);
                    }
                  };
                  return (
                    <form onSubmit={handleSubmit}>

                      {/* ── Tabs ── */}
                      <ul className="nav nav-tabs mb-3" role="tablist">
                        {tabs.map((t) => (
                          <li className="nav-item" key={t.key}>
                            <button
                              type="button"
                              className={`nav-link${activeTab === t.key ? " active" : ""}`}
                              onClick={() => setActiveTab(t.key)}
                            >
                              {t.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* ══════════════════════════════════════
                           TAB 1 — BASIC INFORMATION
                         ══════════════════════════════════════ */}
                      {activeTab === "basicInfo" && (
                        <div>
                          {/* Row 1: Employer Name + Address */}
                          <div className="row mb-2">
                            <div className="col-md-3">
                              <label className="text-label" style={{ fontSize: 12 }}>EMPLOYER NAME</label>
                              <input type="text" className="form-control form-control-sm" name="EmployerName" value={values.EmployerName} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-md-5">
                              <label className="text-label" style={{ fontSize: 12 }}>ADDRESS</label>
                              <input type="text" className="form-control form-control-sm" name="Address" value={values.Address} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-md-2">
                              <label className="text-label" style={{ fontSize: 12 }}>DESIGNATION</label>
                              <input type="text" className="form-control form-control-sm" name="Designation" value={values.Designation} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-md-2">
                              <label className="text-label" style={{ fontSize: 12 }}>BANK</label>
                              <input type="text" className="form-control form-control-sm" name="Bank" value={values.Bank} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                          </div>

                          {/* Row 2: Create Payroll + radio order */}
                          <div className="row mb-2 align-items-center">
                            <div className="col-auto d-flex align-items-center">
                              <input type="checkbox" className="form-check-input me-1" id="CreatePayrollAutomatically" checked={!!values.CreatePayrollAutomatically} onChange={sf("CreatePayrollAutomatically")} />
                              <label htmlFor="CreatePayrollAutomatically" style={{ fontSize: 12, cursor: "pointer" }}>CREATE PAYROLL AUTOMATICALLY</label>
                            </div>
                            {["PFNoWise","SerialNoWise","NameWise","CardNoWise"].map((opt) => (
                              <div key={opt} className="col-auto d-flex align-items-center">
                                <input type="radio" name="PayrollOrderBy" className="form-check-input me-1" value={opt} checked={values.PayrollOrderBy === opt} onChange={handleChange} />
                                <label style={{ fontSize: 12 }}>{opt.replace("Wise"," Wise")}</label>
                              </div>
                            ))}
                          </div>

                          {/* Auto Employee Code generation table */}
                          <div className="row mb-3 mt-3">
                            <div className="col-md-12">
                              <div className="table-responsive">
                                <table className="table table-bordered table-sm text-center align-middle" style={{ fontSize: 12, border: "1px solid #dee2e6" }}>
                                  <thead className="thead-light" style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr>
                                      <th style={{ width: "20%", padding: "8px", fontWeight: "600" }}>Name</th>
                                      <th style={{ width: "10%", padding: "8px", fontWeight: "600" }}>Is Auto?</th>
                                      <th style={{ width: "15%", padding: "8px", fontWeight: "600" }}>Prefix</th>
                                      <th style={{ width: "15%", padding: "8px", fontWeight: "600" }}>Suffix</th>
                                      <th style={{ width: "10%", padding: "8px", fontWeight: "600" }}>Start No</th>
                                      <th style={{ width: "10%", padding: "8px", fontWeight: "600" }}>Padding Digits</th>
                                      <th style={{ width: "15%", padding: "8px", fontWeight: "600" }}>Live Example</th>
                                      <th style={{ width: "10%", padding: "8px", fontWeight: "600" }}>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="align-middle fw-bold text-start ps-3" style={{ padding: "8px" }}>Employee Code</td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <div className="form-check form-switch d-inline-block">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            style={{ cursor: "pointer" }}
                                            name="IsAuto"
                                            checked={!!values.IsAuto}
                                            onChange={(e) => setFieldValue("IsAuto", e.target.checked)}
                                          />
                                        </div>
                                      </td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm text-center"
                                          name="Prefix"
                                          value={values.Prefix || ""}
                                          onChange={handleChange}
                                          disabled={!values.IsAuto}
                                        />
                                      </td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm text-center"
                                          name="Suffix"
                                          value={values.Suffix || ""}
                                          onChange={handleChange}
                                          disabled={!values.IsAuto}
                                        />
                                      </td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-center"
                                          name="StartNo"
                                          value={values.StartNo !== undefined ? values.StartNo : 1}
                                          onChange={handleChange}
                                          disabled={!values.IsAuto}
                                        />
                                      </td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-center"
                                          name="PaddingDigits"
                                          value={values.PaddingDigits !== undefined ? values.PaddingDigits : 0}
                                          onChange={handleChange}
                                          disabled={!values.IsAuto}
                                        />
                                      </td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <span className="badge badge-primary px-2 py-1" style={{ fontSize: 12, color: "white" }}>
                                          {(() => {
                                            if (!values.IsAuto) return "-";
                                            const prefix = values.Prefix || "";
                                            const suffix = values.Suffix || "";
                                            const startNo = values.StartNo !== undefined && values.StartNo !== "" ? values.StartNo : 1;
                                            const padding = values.PaddingDigits !== undefined && values.PaddingDigits !== "" ? parseInt(values.PaddingDigits, 10) : 0;
                                            
                                            let numStr = String(startNo);
                                            if (padding > 0 && numStr.length < padding) {
                                              numStr = numStr.padStart(padding, "0");
                                            }
                                            return `${prefix}${numStr}${suffix}`;
                                          })()}
                                        </span>
                                      </td>
                                      <td className="align-middle" style={{ padding: "8px" }}>
                                        <button
                                          type="submit"
                                          className="btn btn-success btn-xs px-3"
                                          disabled={isSubmitting}
                                        >
                                          Save
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* Row 3: Dept wise + Retirement + Place */}
                          <div className="row mb-3 align-items-center">
                            <div className="col-auto d-flex align-items-center">
                              <input type="checkbox" className="form-check-input me-1" id="DepartmentWisePayroll" checked={!!values.DepartmentWisePayroll} onChange={sf("DepartmentWisePayroll")} />
                              <label htmlFor="DepartmentWisePayroll" style={{ fontSize: 12, cursor: "pointer" }}>DEPARTMENT WISE PAYROLL</label>
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <label style={{ fontSize: 12 }}>RETIREMENT AGE</label>
                              <input type="number" className="form-control form-control-sm" style={{ width: 70 }} name="RetirementAge" value={values.RetirementAge} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <label style={{ fontSize: 12 }}>MIN WAGES</label>
                              <input type="number" className="form-control form-control-sm" style={{ width: 80 }} name="MinWages" value={values.MinWages} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <label style={{ fontSize: 12, fontWeight: 600, color: "#1e40af" }}>FIX MONTH DAYS</label>
                              <input type="number" step="0.01" className="form-control form-control-sm" style={{ width: 75 }} name="FixMonthDays" placeholder="Auto" value={values.FixMonthDays} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <label style={{ fontSize: 12, fontWeight: 600, color: "#047857" }}>WORKING HOURS</label>
                              <input type="number" step="0.5" min="0" max="24" className="form-control form-control-sm" style={{ width: 75 }} name="WorkingHours" placeholder="8" value={values.WorkingHours} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <input type="checkbox" className="form-check-input me-1" id="ESIOnOT" checked={!!values.ESIOnOT} onChange={sf("ESIOnOT")} />
                              <label htmlFor="ESIOnOT" style={{ fontSize: 12, cursor: "pointer" }}>ESI ON OT</label>
                              <input type="checkbox" className="form-check-input ms-2 me-1" id="PFOnOT" checked={!!values.PFOnOT} onChange={sf("PFOnOT")} />
                              <label htmlFor="PFOnOT" style={{ fontSize: 12, cursor: "pointer" }}>PF ON OT</label>
                            </div>
                          </div>

                          {/* Checkbox grid – 3 columns */}
                          <div className="row">
                            {/* Column 1 */}
                            <div className="col-md-4">
                              {[
                                ["SundayInclude",            "SUNDAY INCLUDE"],
                                ["SundayIncludeDeptwise",    "SUNDAY INCLUDE DEPTWISE"],
                                ["HourlyPayment",            "HOURLY PAYMENT"],
                                ["WagesRoundedOff",          "WAGES ROUNDED OFF"],
                                ["ArrearApplicable",         "ARREAR APPLICABLE"],
                                ["PFOnArrear",               "PF ON ARREAR"],
                                ["ESIOnArrear",              "ESI ON ARREAR"],
                                ["AllowancesOnArrear",       "ALLOWANCES ON ARREAR"],
                                ["DirectWagesEntry",         "DIRECT WAGES ENTRY"],
                                ["DirectWagesDepartmentwise","DIRECT WAGES DEPARTMENTWISE"],
                                ["NetPayableRoundedOff",     "NET PAYABLE ROUNDED OFF"],
                                ["CopyDaysToNextEmployee",   "COPY DAYS TO NEXT EMPLOYEE"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                            </div>

                            {/* Column 2 */}
                            <div className="col-md-4">
                              {[
                                ["OpLeaveWWagesInPayrollT",       "OP. LEAVE W/WAGES IN PAYROLL T"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                              <div className="d-flex align-items-center mb-2">
                                <label style={{ fontSize: 12, minWidth: 200 }}>GRATUITY ELIGIBILITY MONTHS</label>
                                <input type="number" className="form-control form-control-sm ms-1" style={{ width: 60 }} name="GratuityEligibilityMonths" value={values.GratuityEligibilityMonths} onChange={handleChange} onBlur={handleBlur} />
                              </div>
                              <div className="d-flex align-items-center mb-2">
                                <label style={{ fontSize: 12, minWidth: 200 }}>GRATUITY PAYABLE DAYS IN MONTH</label>
                                <input type="number" className="form-control form-control-sm ms-1" style={{ width: 60 }} name="GratuityPayableDaysInMonth" value={values.GratuityPayableDaysInMonth} onChange={handleChange} onBlur={handleBlur} />
                              </div>
                              {[
                                ["ShowCompanyNameInDepartment", "SHOW COMPANY NAME IN DEPARTMENT"],
                                ["MultiESICode",                "MULTI ESI CODE"],
                                ["MultiPF",                     "MULTI PF"],
                                ["MultiFactoryFirm",            "MULTI FACTORY FIRM"],
                                ["AllowanceDeductionEditable",  "ALLOWANCE DEDUCTION EDITABLE"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                            </div>

                            {/* Column 3 */}
                            <div className="col-md-4">
                              {[
                                ["CheckDuplicatePFNoEntry",        "CHECK DUPLICATE PF NO ENTRY"],
                                ["CheckDuplicateESINoEntry",       "CHECK DUPLICATE ESI NO ENTRY"],
                                ["NoWeeklyHolidayForDailyWages",   "NO WEEKLY HOLIDAY FOR DAILY WAGES"],
                                ["NoDataOfContractor",             "NO DATA OF CONTRACTOR"],
                                ["BasicEditable",                  "BASIC EDITABLE"],
                                ["PieceWiseCalculation",           "PIECE WISE CALCULATION"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                              <div className="d-flex align-items-center mb-2">
                                <label style={{ fontSize: 12, minWidth: 120 }}>FIRM HOLIDAY</label>
                                <select className="form-control form-control-sm ms-1" style={{ width: 130 }} name="FirmHoliday" value={values.FirmHoliday} onChange={handleChange}>
                                  {["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"].map((d) => (
                                    <option key={d} value={d}>{d}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ══════════════════════════════════════
                           TAB 2 — OTHER INFORMATION
                         ══════════════════════════════════════ */}
                      {activeTab === "otherInfo" && (
                        <div className="row">
                          {/* Left panel */}
                          <div className="col-md-3 border-end pe-3">
                            {/* ESI / PF / Bonus / Gratuity Rates … */}
                            {[
                              { name: "ESIEnabled",    label: "ESI",            btnLabel: "ESI",   onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setEsiModalOpen(true); EsiParamFetch(firmId); } },
                              { name: "PFEnabled",     label: "PF",             btnLabel: "PF",    onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setPfModalOpen(true); PfParamFetch(firmId); } },
                              { name: "BonusEnabled",  label: "Bonus",          btnLabel: "BONUS", onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setBonusModalOpen(true); BonusParamFetch(firmId); } },
                              { name: "GratuityRates", label: "Gratuity Rates", btnLabel: "GRA",   onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setGratuityModalOpen(true); GratuityParamFetch(firmId); } },
                            ].map(({ name, label, btnLabel, onBtnClick }) => (
                              <div key={name} className="d-flex align-items-center justify-content-between mb-2">
                                <div className="d-flex align-items-center gap-2">
                                  <input type="checkbox" className="form-check-input" id={name} checked={!!values[name]} onChange={sf(name)} />
                                  <label htmlFor={name} className="mb-0" style={{ fontSize: 12, cursor: "pointer", fontWeight: 500 }}>{label}</label>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm ms-2"
                                  style={{ width: "85px", height: "32px", fontSize: "12px", fontWeight: "600", padding: "2px 8px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                                  onClick={onBtnClick}
                                >
                                  {btnLabel}
                                </button>
                              </div>
                            ))}
                            {[
                              { label: "Group Insurance", btnLabel: "GI", onBtnClick: () => { const firmId = sessionFirmId || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setGiModalOpen(true); GIParamFetch(firmId); } },
                              { label: "Bidi Rates",      btnLabel: "Rates", onBtnClick: () => { const firmId = sessionFirmId || JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setBidiModalOpen(true); BidiParamFetch(firmId); } },
                            ].map(({ label, btnLabel, onBtnClick }) => (
                              <div key={label} className="d-flex align-items-center justify-content-between mb-2 ms-4">
                                <span style={{ fontSize: 12, fontWeight: 500 }}>{label}</span>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm ms-2"
                                  style={{ width: "85px", height: "32px", fontSize: "12px", fontWeight: "600", padding: "2px 8px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                                  onClick={onBtnClick}
                                >
                                  {btnLabel}
                                </button>
                              </div>
                            ))}

                            <hr className="my-2" />

                            {/* Leave / deduction checkboxes */}
                            {[
                              ["CRLDays",     "CRL Days"],
                              ["OverTime",    "OverTime"],
                              ["Recovery",    "Recovery"],
                              ["Advance",     "Advance"],
                              ["TDS",         "TDS"],
                              ["AdvanceBonus","Advance Bonus"],
                              ["PFAdvRefund", "PF Adv. Refund"],
                            ].map(([name, label]) => (
                              <div key={name} className="d-flex align-items-center mb-1">
                                <input type="checkbox" className="form-check-input me-2" id={name} checked={!!values[name]} onChange={sf(name)} />
                                <label htmlFor={name} style={{ fontSize: 12, cursor: "pointer" }}>{label}</label>
                              </div>
                            ))}

                            <hr className="my-2" />

                            <div className="d-flex align-items-center mb-2 gap-2">
                              <label style={{ fontSize: 12, minWidth: 90 }}>PF Section</label>
                              <input type="text" className="form-control form-control-sm" style={{ width: 100 }} name="PFSection" value={values.PFSection} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                          </div>

                          {/* Middle panel - 2 sub columns to keep vertical height compact */}
                          <div className="col-md-5 border-end pe-3">
                            <div className="row g-1">
                              <div className="col-6">
                                {[
                                  ["Days26Working",                    "26 DAYS WORKING"],
                                  ["Days26WorkingEmployeeWise",        "26 DAYS WORKING EMPLOYEEWISE"],
                                  ["MonthDayWOSundayForDailyWages",    "MONTH DAY W/O SUNDAY FOR DAILY WAGES"],
                                  ["AC2122OnFixedMaxPFWages",          "A/C 21 22 ON FIXED MAX PF WAGES"],
                                  ["OverLimitESICalcOnESILimit",       "OVER LIMIT ESI CALCULATE ON ESI LIMIT"],
                                  ["FullESIByEmployer",                "FULL ESI BY EMPLOYER"],
                                ].map(([name, label]) => (
                                  <div key={name} className="d-flex align-items-center mb-2">
                                    <input type="checkbox" className="form-check-input me-2 flex-shrink-0" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label htmlFor={name} style={{ fontSize: 11.5, cursor: "pointer", lineHeight: "1.2" }}>{label}</label>
                                  </div>
                                ))}
                              </div>
                              <div className="col-6">
                                {[
                                  ["TransactionLocked",                "TRANSACTION LOCKED"],
                                  ["OvertimeOnGrossWages",             "OVERTIME ON GROSS WAGES"],
                                  ["MinWagesEditable",                 "MIN WAGES EDITABLE"],
                                  ["FullPFByEmployer",                 "FULL PF BY EMPLOYER"],
                                  ["MaxLeaveValidate",                 "MAX LEAVE VALIDATE"],
                                  ["OvertimeOn26Days",                 "OVERTIME ON 26 DAYS"],
                                ].map(([name, label]) => (
                                  <div key={name} className="d-flex align-items-center mb-2">
                                    <input type="checkbox" className="form-check-input me-2 flex-shrink-0" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label
                                      htmlFor={name}
                                      style={{ fontSize: 11.5, cursor: "pointer", lineHeight: "1.2" }}
                                      title={
                                        name === "OvertimeOn26Days"
                                          ? "Divides Monthly Basic/Gross by 26 days for overtime calculation instead of calendar month days (30/31)"
                                          : name === "MaxLeaveValidate"
                                          ? "Validates entered leaves against available balance so leaves cannot exceed allowed limit"
                                          : ""
                                      }
                                    >
                                      {label}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Right panel – Security Password & Extra Pay Selection */}
                          <div className="col-md-4">
                            {/* Employee Delete Security Password (Ultra-compact) */}
                            <div className="border mb-1 p-1 rounded" style={{ borderColor: "#f5c6cb", backgroundColor: "#fff5f5" }}>
                              <div className="d-flex align-items-center justify-content-between mb-1">
                                <span className="d-flex align-items-center fw-bold text-danger" style={{ fontSize: 10.5 }}>
                                  <i className="fas fa-user-shield me-1" />
                                  Employee Delete Security Password
                                </span>
                                <span className="badge bg-danger text-white px-1 py-0" style={{ fontSize: "8.5px" }}>Encrypted</span>
                              </div>
                              <div className="input-group input-group-sm">
                                <input
                                  type={showDeletePass ? "text" : "password"}
                                  className="form-control form-control-sm"
                                  name="DeletePassword"
                                  placeholder="Delete Authorization Password"
                                  value={values.DeletePassword || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  autoComplete="new-password"
                                  style={{ letterSpacing: showDeletePass ? "normal" : "2px", height: 22, fontSize: 10, padding: "2px 6px" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm py-0 px-2"
                                  onClick={() => setShowDeletePass(!showDeletePass)}
                                  title={showDeletePass ? "Hide password" : "Show password"}
                                  style={{ height: 22 }}
                                >
                                  <i className={`fas ${showDeletePass ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 10 }} />
                                </button>
                              </div>
                            </div>

                            {/* Extra Pay Configuration Card (Ultra-compact) */}
                            <div className="card border shadow-sm mb-2">
                              <div className="card-header py-1 px-2.5 bg-light">
                                <h6 className="card-title mb-0" style={{ fontSize: 11.5, color: "#1565c0", fontWeight: 600 }}>Extra Pay Configuration</h6>
                              </div>
                              <div className="card-body p-2">
                                <div className="row g-1">
                                  <div className="col-4">
                                    <div className="mb-0">
                                      <label className="text-label mb-0" style={{ fontSize: 10.5 }}>Extra Pay 1</label>
                                      <select
                                        className="form-control form-control-sm px-1"
                                        style={{ height: 26, fontSize: 11 }}
                                        name="F_ExtraPayMaster1"
                                        value={values.F_ExtraPayMaster1 || ""}
                                        onChange={handleChange}
                                      >
                                        <option value="">-- Select --</option>
                                        {extraPayMasterList
                                          .filter((m) => {
                                            if (m.IsNotInUse || (m.IsActive !== undefined && !m.IsActive)) {
                                              if (String(m.Id) !== String(values.F_ExtraPayMaster1)) return false;
                                            }
                                            const val2 = values.F_ExtraPayMaster2;
                                            const val3 = values.F_ExtraPayMaster3;
                                            return (!val2 || val2 == 0 || String(m.Id) !== String(val2)) &&
                                                   (!val3 || val3 == 0 || String(m.Id) !== String(val3));
                                          })
                                          .map((m) => (
                                            <option key={m.Id} value={m.Id}>{m.ExtraPayName}</option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="mb-0">
                                      <label className="text-label mb-0" style={{ fontSize: 10.5 }}>Extra Pay 2</label>
                                      <select
                                        className="form-control form-control-sm px-1"
                                        style={{ height: 26, fontSize: 11 }}
                                        name="F_ExtraPayMaster2"
                                        value={values.F_ExtraPayMaster2 || ""}
                                        onChange={handleChange}
                                      >
                                        <option value="">-- Select --</option>
                                        {extraPayMasterList
                                          .filter((m) => {
                                            if (m.IsNotInUse || (m.IsActive !== undefined && !m.IsActive)) {
                                              if (String(m.Id) !== String(values.F_ExtraPayMaster2)) return false;
                                            }
                                            const val1 = values.F_ExtraPayMaster1;
                                            const val3 = values.F_ExtraPayMaster3;
                                            return (!val1 || val1 == 0 || String(m.Id) !== String(val1)) &&
                                                   (!val3 || val3 == 0 || String(m.Id) !== String(val3));
                                          })
                                          .map((m) => (
                                            <option key={m.Id} value={m.Id}>{m.ExtraPayName}</option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="mb-0">
                                      <label className="text-label mb-0" style={{ fontSize: 10.5 }}>Extra Pay 3</label>
                                      <select
                                        className="form-control form-control-sm px-1"
                                        style={{ height: 26, fontSize: 11 }}
                                        name="F_ExtraPayMaster3"
                                        value={values.F_ExtraPayMaster3 || ""}
                                        onChange={handleChange}
                                      >
                                        <option value="">-- Select --</option>
                                        {extraPayMasterList
                                          .filter((m) => {
                                            if (m.IsNotInUse || (m.IsActive !== undefined && !m.IsActive)) {
                                              if (String(m.Id) !== String(values.F_ExtraPayMaster3)) return false;
                                            }
                                            const val1 = values.F_ExtraPayMaster1;
                                            const val2 = values.F_ExtraPayMaster2;
                                            return (!val1 || val1 == 0 || String(m.Id) !== String(val1)) &&
                                                   (!val2 || val2 == 0 || String(m.Id) !== String(val2));
                                          })
                                          .map((m) => (
                                            <option key={m.Id} value={m.Id}>{m.ExtraPayName}</option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex align-items-center my-1">
                              <input type="checkbox" className="form-check-input me-2" id="BonusMonthlyInPayroll" checked={!!values.BonusMonthlyInPayroll} onChange={sf("BonusMonthlyInPayroll")} />
                              <label htmlFor="BonusMonthlyInPayroll" style={{ fontSize: 12, cursor: "pointer" }}>Bonus (Monthly) in Payroll</label>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ══════════════════════════════════════
                           TAB 3 — REPORT SETTINGS
                         ══════════════════════════════════════ */}
                      {activeTab === "reportSettings" && (
                        <div className="row">
                          {/* Card 1: Wages Register & Department */}
                          <div className="col-md-4 mb-3">
                            <div className="card border shadow-sm h-100">
                              <div className="card-header py-2 px-3 bg-light border-bottom">
                                <h6 className="card-title mb-0" style={{ fontSize: 13, color: "#1e40af", fontWeight: 700 }}>
                                  <i className="fas fa-file-invoice me-2 text-primary" />
                                  Wages Register & Department
                                </h6>
                              </div>
                              <div className="card-body p-3">
                                {[
                                  ["MultiDepartmentSelection",          "MULTI DEPARTMENT SELECTION"],
                                  ["DepartmentInWagesRegisterOrderWise", "DEPARTMENT IN WAGES REGISTER ORDER WISE"],
                                  ["LeaveWithWagesDepartmentwise",       "LEAVE WITH WAGES DEPARTMENTWISE"],
                                  ["PFESIDuePaidDepartmentwise",         "PF ESI DUE PAID DEPARTMENTWISE"],
                                  ["NoPensionDataInWagesRegister",        "NO PENSION DATA IN WAGES REGISTER"],
                                  ["AskToUpdatePaid",                    "ASK TO UPDATE PAID"],
                                ].map(([name, label]) => (
                                  <div key={name} className="d-flex align-items-center mb-3">
                                    <input type="checkbox" className="form-check-input me-2 flex-shrink-0" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label htmlFor={name} className="mb-0" style={{ fontSize: 12, cursor: "pointer", fontWeight: 500, lineHeight: "1.3" }}>{label}</label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Card 2: Statutory / PF & ESI Reports */}
                          <div className="col-md-4 mb-3">
                            <div className="card border shadow-sm h-100">
                              <div className="card-header py-2 px-3 bg-light border-bottom">
                                <h6 className="card-title mb-0" style={{ fontSize: 13, color: "#047857", fontWeight: 700 }}>
                                  <i className="fas fa-landmark me-2 text-success" />
                                  Statutory / PF & ESI Reports
                                </h6>
                              </div>
                              <div className="card-body p-3">
                                {[
                                  ["AddAbsentInPFChallan",  "ADD ABSENT IN PF CHALLAN"],
                                  ["DontShowNCPInForm10C",  "DONT SHOW NCP IN FORM 10C"],
                                  ["ShowForm3AWith0",       "SHOW FORM 3A WITH 0"],
                                  ["EntryFromExternal",     "ENTRY FROM EXTERNAL"],
                                ].map(([name, label]) => (
                                  <div key={name} className="d-flex align-items-center mb-3">
                                    <input type="checkbox" className="form-check-input me-2 flex-shrink-0" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label htmlFor={name} className="mb-0" style={{ fontSize: 12, cursor: "pointer", fontWeight: 500, lineHeight: "1.3" }}>{label}</label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Card 3: Bonus, Leave & Overtime Reports */}
                          <div className="col-md-4 mb-3">
                            <div className="card border shadow-sm h-100">
                              <div className="card-header py-2 px-3 bg-light border-bottom">
                                <h6 className="card-title mb-0" style={{ fontSize: 13, color: "#b45309", fontWeight: 700 }}>
                                  <i className="fas fa-coins me-2 text-warning" />
                                  Bonus, Leave & Overtime Reports
                                </h6>
                              </div>
                              <div className="card-body p-3">
                                {[
                                  ["MonthDayWithWHInBonus",         "MONTH DAY WITH WH IN BONUS"],
                                  ["BonusOnWorkingDays",            "BONUS ON WORKING DAYS"],
                                  ["BonusOnMinWages",               "BONUS ON MIN WAGES"],
                                  ["LeaveWagesAmountOnBasicSalary", "LEAVE WAGES AMOUNT ON BASIC SALARY"],
                                  ["DisplayLeaveWagesPayment",      "DISPLAY LEAVE W/WAGES PAYMENT"],
                                  ["CRLOnMonthDays",                "CRL ON MONTH DAYS"],
                                  ["AddOvertimeAmountInNetPayable", "ADD OVERTIME AMOUNT IN NET PAYABLE"],
                                  ["DoubleOvertimeAmount",          "DOUBLE OVERTIME AMOUNT"],
                                ].map(([name, label]) => (
                                  <div key={name} className="d-flex align-items-center mb-3">
                                    <input type="checkbox" className="form-check-input me-2 flex-shrink-0" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label htmlFor={name} className="mb-0" style={{ fontSize: 12, cursor: "pointer", fontWeight: 500, lineHeight: "1.3" }}>{label}</label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ══════════════════════════════════════
                           TAB 4 — ADDRESS DETAILS
                         ══════════════════════════════════════ */}
                      {activeTab === "addressDetails" && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="text-label fw-bold" style={{ fontSize: 14 }}>FACTORY ACT ADDRESS DETAILS</label>
                                  <textarea className="form-control" rows={6} name="FactoryActAddressDetails" value={values.FactoryActAddressDetails} onChange={handleChange} onBlur={handleBlur} />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="text-label fw-bold" style={{ fontSize: 14 }}>PF ADDRESS DETAILS</label>
                                  <textarea className="form-control" rows={6} name="PFAddressDetails" value={values.PFAddressDetails} onChange={handleChange} onBlur={handleBlur} />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="text-label fw-bold" style={{ fontSize: 14 }}>ESI ADDRESS DETAILS</label>
                                  <textarea className="form-control" rows={6} name="ESIAddressDetails" value={values.ESIAddressDetails} onChange={handleChange} onBlur={handleBlur} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ── Submit / Cancel ── */}
                      <div className="mt-3 pt-2 border-top d-flex align-items-center gap-2">
                        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        <button type="button" className="btn btn-danger light" onClick={() => navigate("/PayrollParameter")}>
                          Cancel
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {/* ── Professional Statutory Configuration Modals ── */}
      <PFModal
        isOpen={pfModalOpen}
        onClose={() => setPfModalOpen(false)}
        form={pfForm}
        setField={setPF}
        editMode={pfEditMode}
        setEditMode={setPfEditMode}
        records={pfRecords}
        index={pfIndex}
        onNavigate={navigatePf}
        onAdd={() => {
          setPfForm({ ...pfFormInit });
          setPfEditMode(true);
        }}
        onSave={handlePFSave}
        onCancel={() => {
          if (pfRecords.length > 0) {
            loadPfRecord(pfRecords[pfIndex]);
            setPfEditMode(false);
          } else {
            setPfModalOpen(false);
          }
        }}
      />

      <ESIModal
        isOpen={esiModalOpen}
        onClose={() => setEsiModalOpen(false)}
        form={esiForm}
        setField={setESI}
        editMode={esiEditMode}
        setEditMode={setEsiEditMode}
        records={esiRecords}
        index={esiIndex}
        onNavigate={navigateEsi}
        onAdd={() => {
          setEsiForm({ ...esiFormInit });
          setEsiEditMode(true);
        }}
        onSave={handleESISave}
        onCancel={() => {
          if (esiRecords.length > 0) {
            loadEsiRecord(esiRecords[esiIndex]);
            setEsiEditMode(false);
          } else {
            setEsiModalOpen(false);
          }
        }}
      />

      <BonusModal
        isOpen={bonusModalOpen}
        onClose={() => setBonusModalOpen(false)}
        form={bonusForm}
        setField={setBonus}
        editMode={bonusEditMode}
        setEditMode={setBonusEditMode}
        records={bonusRecords}
        index={bonusIndex}
        onNavigate={navigateBonus}
        onAdd={() => {
          setBonusForm({ ...bonusFormInit });
          setBonusEditMode(true);
        }}
        onSave={handleBonusSave}
        onCancel={() => {
          if (bonusRecords.length > 0) {
            loadBonusRecord(bonusRecords[bonusIndex]);
            setBonusEditMode(false);
          } else {
            setBonusModalOpen(false);
          }
        }}
      />

      <GratuityModal
        isOpen={gratuityModalOpen}
        onClose={() => setGratuityModalOpen(false)}
        form={gratuityForm}
        setField={setGratuity}
        editMode={gratuityEditMode}
        setEditMode={setGratuityEditMode}
        records={gratuityRecords}
        index={gratuityIndex}
        onNavigate={navigateGratuity}
        onAdd={() => {
          setGratuityForm({ ...gratuityFormInit });
          setGratuityEditMode(true);
        }}
        onSave={handleGratuitySave}
        onCancel={() => {
          if (gratuityRecords.length > 0) {
            loadGratuityRecord(gratuityRecords[gratuityIndex]);
            setGratuityEditMode(false);
          } else {
            setGratuityModalOpen(false);
          }
        }}
      />

      <GIModal
        isOpen={giModalOpen}
        onClose={() => setGiModalOpen(false)}
        form={giForm}
        setField={setGI}
        editMode={giEditMode}
        setEditMode={setGiEditMode}
        records={giRecords}
        index={giIndex}
        onNavigate={navigateGi}
        onAdd={() => {
          setGiForm({ ...giFormInit });
          setGiEditMode(true);
        }}
        onSave={handleGISave}
        onCancel={() => {
          if (giRecords.length > 0) {
            loadGiRecord(giRecords[giIndex]);
            setGiEditMode(false);
          } else {
            setGiModalOpen(false);
          }
        }}
      />

      <BidiModal
        isOpen={bidiModalOpen}
        onClose={() => setBidiModalOpen(false)}
        form={bidiForm}
        setField={setBidi}
        editMode={bidiEditMode}
        setEditMode={setBidiEditMode}
        records={bidiRecords}
        index={bidiIndex}
        onNavigate={navigateBidi}
        onAdd={() => {
          setBidiForm({ ...bidiFormInit });
          setBidiEditMode(true);
        }}
        onSave={handleBidiSave}
        onCancel={() => {
          if (bidiRecords.length > 0) {
            loadBidiRecord(bidiRecords[bidiIndex]);
            setBidiEditMode(false);
          } else {
            setBidiModalOpen(false);
          }
        }}
      />
      </div>
    </Fragment>
  );
};

export default AddEdit_PayrollParameter;
